export const maxInputWidth: string = "26rem";
